import { Content, Wrapper } from "./styles";
import { QuotesIco } from "../../components/Icons/Quotes";
import { StyledButton } from "components/generic";
import { theme } from "../../styles/theme";
import { useTranslation } from "react-i18next";

export const Review = () => {
  const { t } = useTranslation("home");

  return (
    <Wrapper>
      <div>
        <Content>
          {QuotesIco}
          <p>{t("review")}</p>
          <div>
            <div>
              <span style={{ color: theme.colors.text }} id="bold">
                Sandra Brouwer
              </span>
              <span style={{ color: theme.colors.primary }}>
                {t("hostedSince")}
              </span>
            </div>
            <StyledButton outline={true} p="16px 32px">
              <a
                href="https://www.google.com/search?q=hospi+housing"
                target="_blank"
              >
                {t("buttons.allReviews")}
              </a>
            </StyledButton>
          </div>
        </Content>
      </div>
    </Wrapper>
  );
};
